import { useAuth } from "@/contexts/AuthContext";
import { Navigate, useParams } from "react-router-dom";
import { SEOHead } from "@/components/SEOHead";
import { ChatInterface } from "@/components/admin/ChatInterface";

const SMSConversation = () => {
  const { user, loading } = useAuth();
  const { phoneNumberId, conversationId } = useParams<{ 
    phoneNumberId: string;
    conversationId: string;
  }>();

  if (loading) {
    return <div className="flex items-center justify-center min-h-screen">Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  return (
    <>
      <SEOHead 
        title="SMS Conversation"
        description="View and respond to SMS messages"
      />
      
      <div className="h-[100dvh] w-full flex flex-col bg-background">
        <ChatInterface 
          conversationId={conversationId!}
          phoneNumberId={phoneNumberId!}
        />
      </div>
    </>
  );
};

export default SMSConversation;
